import React from 'react';
import { Route, Switch } from 'react-router-dom';

import List from './list';
import Site from './site';

export default () => (
  <Switch>
    <Route path="/sites/:id" component={Site} />
    <Route component={List} />
  </Switch>
);
